import type { AcceptIncomingCallEventPublisher } from '@usecases/accept-incoming-call.usecase';
import { BusIframe } from '@main/bus-layer/bus-iframe';
import type {
  BusAsyncEvent,
  BusEvent,
} from '@main/utils/bus-event-promisifier';
import { BusEventsPromisifier } from '@main/utils/bus-event-promisifier';
import { Logger } from '@main/utils/logger';

export type CallConnectedStatusPayload = { status: string };

export class AcceptIncomingCallPublisher
  implements AcceptIncomingCallEventPublisher
{
  private logger: Logger;
  constructor() {
    this.logger = new Logger();
  }

  async publish(): Promise<void> {
    const busIframe = await BusIframe.getIframe();

    const busEvent: BusEvent = {
      type: 'DIALER.ACCEPT',
    };

    const asyncEvent: BusAsyncEvent<CallConnectedStatusPayload> = {
      event: busEvent,
      target: busIframe,
      asyncEventName: 'DIALER.CALL_STATUS',
      shouldResolve(payload: CallConnectedStatusPayload) {
        return payload.status === 'connected';
      },
    };

    this.logger.info('Publisher: Accepting incoming call', {
      action: 'AcceptIncomingCall',
    });

    await BusEventsPromisifier.promisifyAsyncEvent(asyncEvent);
  }
}
